import OrganisationManage from "./manage"

export default OrganisationManage
